<template>
    <div class="tw-p-2">
      <div class="tw-min-h-[400px] tw-bg-white">
          <h1>Foodshow on demand</h1>
      </div>
    </div>
  </template>
  
  <script setup></script>
  
  <style>
  
  </style>